"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LEGIFRANCE_CODES_URL = exports.LEGIFRANCE_BASE_URL = void 0;
exports.LEGIFRANCE_BASE_URL = 'https://www.legifrance.gouv.fr';
exports.LEGIFRANCE_CODES_URL = "".concat(exports.LEGIFRANCE_BASE_URL, "/codes/id");
//# sourceMappingURL=urls.js.map